import { useTranslation } from 'react-i18next'

/** What an inactive toggle holds back: each kind names its own button. */
export type InactiveKind = 'drivers' | 'trucks' | 'trailers' | 'agents' | 'recipients'

/**
 * Says how many inactive rows a list holds back, and shows or hides them. A carrier's fleet
 * did first (TRKC-107); every list does since TRKC-110 item 2 — inactive records are hidden
 * unless somebody asks for them.
 *
 * The button names its list in its own words ("Show inactive trucks"), because a carrier's
 * page holds three of them. A bare "Show deactivated (1)" twice in a screen reader's list of
 * buttons said nothing about which was which (Copilot on #55).
 */
export function InactiveToggle({
  kind,
  controls,
  count,
  shown,
  onToggle,
}: {
  kind: InactiveKind
  /** The id of what the button shows or hides: the list, or the line standing in for it. */
  controls: string
  /** How many inactive rows the list holds; none, and there is no button. */
  count: number
  shown: boolean
  onToggle: () => void
}) {
  const { t } = useTranslation()

  if (count === 0) {
    return null
  }

  return (
    <p className="inactive-toggle">
      <button
        type="button"
        className="button button--quiet"
        aria-expanded={shown}
        aria-controls={controls}
        onClick={onToggle}
      >
        {shown ? t(`inactive.hide.${kind}`) : t(`inactive.show.${kind}`, { count })}
      </button>
    </p>
  )
}
